import PropTypes from 'prop-types'

import styles from './TitledBox.module.css'

export const TitledBox = ({ children, className, error, titulo, activo, ref }) => {
  return (
    <div
      ref={ref}
      className={`${className || ''} ${styles.container} ${error ? styles.errorContainer : ''} ${activo ? styles.activo : ''}`}
    >
      {error && <div className={styles.error}>{error}</div>}
      <span className={styles.titulo}>{titulo}</span>
      {children}
    </div>
  )
}

TitledBox.propTypes = {
  titulo: PropTypes.node.isRequired,
  className: PropTypes.string,
  error: PropTypes.node,
  children: PropTypes.node.isRequired,
  activo: PropTypes.bool,
  ref: PropTypes.oneOfType([PropTypes.func, PropTypes.object])
}
